import { styled } from 'styled-components'

import { SegmentedProgressBar } from '../decorative/SegmentedProgressBar'
import { SecondaryHeaderWrapper } from '../global/CommonStyling'
import { LogoIconType } from '../global/ComponentProps'
import { ChangeLanguageButtonOptions, PrimaryTopBar, PrimaryTopBarVariantOptions } from '../navigation/PrimaryTopBar'
import { SecondaryTopBar } from '../navigation/SecondaryTopBar'
import { PAGE_EXIT_BUTTON_CLASS } from '../utilities/helpers'
import { WizardHeaderButtonProps, WizardPageSubHeaderProps } from './WizardTypes'

interface WizardHeaderProps {
  shouldShowMainHeader: boolean
  title?: string
  icon: LogoIconType
  headerButtonProps?: WizardHeaderButtonProps
  changeLanguageButtonOptions?: ChangeLanguageButtonOptions
  subHeaderOptions?: WizardPageSubHeaderProps
  fixToTop?: boolean
  additionalText?: string
  hideBoxShadow?: boolean
  transparentTopBar?: boolean
  topBarVariant?: PrimaryTopBarVariantOptions
}

const Header = styled.header`
  width: 100%;
`

export const WizardHeader = (props: WizardHeaderProps) => {
  const {
    subHeaderOptions,
    fixToTop,
    additionalText,
    hideBoxShadow,
    transparentTopBar,
    topBarVariant = 'compact',
    headerButtonProps,
    changeLanguageButtonOptions,
  } = props
  const progressBarOptions = subHeaderOptions?.progressBarOptions
  const secondaryTopBarMenuProps = subHeaderOptions?.secondaryTopBarMenuProps

  return (
    <Header>
      {props.shouldShowMainHeader && (
        <PrimaryTopBar
          actionButtonOptions={
            headerButtonProps && {
              className: PAGE_EXIT_BUTTON_CLASS,
              label: headerButtonProps.headerButtonLabel,
              onClick: headerButtonProps.onHeaderButtonClick,
            }
          }
          changeLanguageButtonOptions={changeLanguageButtonOptions}
          icon={props.icon}
          serviceName={props.title}
          userDisplayName={additionalText}
          variant={topBarVariant}
          isTransparent={transparentTopBar}
        />
      )}
      {subHeaderOptions && subHeaderOptions.isFixedSubHeader && (
        <SecondaryHeaderWrapper $fixedToTop={!!fixToTop} data-testid="secondary-header">
          <SecondaryTopBar
            title={subHeaderOptions.title}
            description={subHeaderOptions.description}
            small={fixToTop}
            previousLinkButtonProps={subHeaderOptions.previousLinkButtonProps}
            buttonProps={subHeaderOptions.buttonProps}
            menu={secondaryTopBarMenuProps}
            hideBoxShadow={hideBoxShadow}
          />
          {progressBarOptions && <SegmentedProgressBar {...progressBarOptions} />}
        </SecondaryHeaderWrapper>
      )}
    </Header>
  )
}
